var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.762 287.487H47.9145C21.4364 287.487 -0.0283203 308.952 -0.0283203 335.43V463.278C-0.0283203 489.756 21.4364 511.22 47.9145 511.22H175.762C202.24 511.22 223.705 489.756 223.705 463.278V335.43C223.705 308.952 202.24 287.487 175.762 287.487Z",
    fill: "#3AE4DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.495 511.22C461.278 511.22 511.362 461.136 511.362 399.354C511.362 337.572 461.278 287.487 399.495 287.487C337.713 287.487 287.629 337.572 287.629 399.354C287.629 461.136 337.713 511.22 399.495 511.22Z",
    fill: "#FF3446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.297 223.564C155.216 223.548 147.291 221.332 140.373 217.155C133.455 212.978 127.804 206.996 124.026 199.852C120.249 192.708 118.487 184.67 118.93 176.601C119.373 168.531 122.004 160.735 126.541 154.047L218.176 19.8069C222.34 13.7028 227.932 8.70789 234.466 5.25609C241 1.80428 248.277 0 255.667 0C263.056 0 270.334 1.80428 276.868 5.25609C283.401 8.70789 288.993 13.7028 293.158 19.8069L384.793 154.079C389.332 160.764 391.966 168.559 392.41 176.628C392.854 184.696 391.092 192.733 387.314 199.876C383.535 207.019 377.883 212.998 370.963 217.172C364.043 221.345 356.117 223.555 348.037 223.564H163.297Z",
    fill: "#FFDC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.9e71cf96eda9d7c40fa543d88c782a5d.svg";
export { ForwardRef as ReactComponent };